import React from 'react';
import { Button, Paper } from '@mui/material';

import { isProfileTruss } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';
import { DistanceField } from '@paragon/material';

import { setProfileTrussOverhangDistance } from '../../../../store/actions/editComponentActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { propertiesShouldBeViewOnly } from '../../../../store/selectors/viewOnlyModeSelectors';
import { setTrussEditsPanel } from '../../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export function OverhangMacrosPanel() {
  const dispatch = useAppDispatch();

  const isViewOnly = useAppSelector(propertiesShouldBeViewOnly);
  const componentDesign = useAppSelector(getActiveComponentDesign);

  if (componentDesign == null || !isProfileTruss(componentDesign.component)) return null;

  return (
    <PropertiesPanel title="Adjust Overhang">
      <DistanceField
        label="Left Overhang Distance"
        value={componentDesign.component.leftOverhang.distance}
        onSubmit={(value) => {
          dispatch(setProfileTrussOverhangDistance('Left', value, componentDesign!.guid));
        }}
        disabled={isViewOnly}
      />

      <DistanceField
        label="Right Overhang Distance"
        value={componentDesign.component.rightOverhang.distance}
        onSubmit={(value) => {
          dispatch(setProfileTrussOverhangDistance('Right', value, componentDesign!.guid));
        }}
        disabled={isViewOnly}
      />

      <Paper elevation={1} sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', p: 1, borderRadius: 0 }}>
        <Button
          variant="outlined"
          onClick={() => {
            dispatch(setTrussEditsPanel(null));
          }}
        >
          Close
        </Button>
      </Paper>
    </PropertiesPanel>
  );
}
